var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6164 6.66301C19.9826 6.93639 19.293 7.13313 18.5826 7.20976C19.3201 6.77161 19.8724 6.07941 20.1359 5.26302C19.4438 5.67472 18.6857 5.9634 17.8951 6.11627C17.5646 5.76302 17.165 5.4816 16.721 5.28955C16.2771 5.0975 15.7983 4.99894 15.3146 5.00001C13.3575 5.00001 11.7836 6.58639 11.7836 8.53312C11.7836 8.80649 11.8167 9.07986 11.8706 9.34288C8.94011 9.18962 6.32652 7.78963 4.58895 5.64616C4.27235 6.18693 4.10644 6.80265 4.10848 7.42928C4.10848 8.65531 4.73185 9.73637 5.68244 10.3722C5.12224 10.3501 4.57517 10.1961 4.0857 9.92276V9.96625C4.0857 11.6831 5.2993 13.1059 6.91675 13.4331C6.61306 13.512 6.30064 13.5523 5.98687 13.5532C5.75699 13.5532 5.53954 13.5304 5.32001 13.4994C5.76735 14.8993 7.07 15.9162 8.62117 15.9493C7.40757 16.8999 5.88747 17.4591 4.23689 17.4591C3.94073 17.4591 3.66736 17.4487 3.38364 17.4156C4.94931 18.42 6.80699 18.9999 8.80756 18.9999C15.3022 18.9999 18.856 13.6195 18.856 8.94939C18.856 8.79614 18.856 8.64288 18.8457 8.48963C19.5332 7.98638 20.1359 7.36301 20.6164 6.66301Z",
    fill: "#051655"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTwitter);
export default __webpack_public_path__ + "static/media/socialTwitter.943c004fad53db0e3abce5fd9cc19fd3.svg";
export { ForwardRef as ReactComponent };